import {React} from '$src/handy'
import {any as anyPropType} from 'prop-types'
import {AppContainer} from 'react-hot-loader'
import RootRoutes from './routing/RootRoutes'
import {IStore, createStateStore} from './Store'
import {createStore, applyMiddleware} from 'redux'
import createSagaMiddleware from 'redux-saga'
import {rootSaga} from '$src/bootstrap/rootSaga'
import './App.css'

interface Props {
  css?: any
}

interface State {
  store: IStore
  RootRoutes: typeof RootRoutes
}

export class App extends React.Component<Props, State> {
  props: Props
  state: State

  static childContextTypes = {
    store: anyPropType,
  }

  getChildContext() {
    return {store: this.state.store}
  }

  constructor(props: Props) {
    super(props)
    const mstStore = createStateStore()
    function sagaLogger(level: any, message: any, error: $FixMe = '') {
      // ignore error
      if (error.includes('Generator is already')) return

      if (typeof window === 'undefined') {
        // @ts-ignore
        console.log(
          `redux-saga ${level}: ${message}\n${(error && error.stack) || error}`,
        )
      } else {
        // @ts-ignore
        console[level](message, error)
      }
    }

    // in your middleware setup code
    const sagaMiddleware = createSagaMiddleware({
      context: {mstStore},
      logger: sagaLogger,
    })

    // @ts-ignore a dummy redux store so that redux-saga won't complain
    const reduxStore = createStore(
      () => null,
      null,
      applyMiddleware(sagaMiddleware),
    )

    if (process.env.NODE_ENV === 'development') {
      const {connectReduxDevtools} = require('mst-middlewares')
      const remoteDev = require('remotedev')
      connectReduxDevtools(remoteDev, mstStore)
    }

    // @ts-ignore
    mstStore.sagaMiddleware = sagaMiddleware

    sagaMiddleware.run(rootSaga)

    // @ts-ignore
    window.s = mstStore

    this.state = {
      store: mstStore,
      RootRoutes,
    }

    setTimeout(() => {
      this.state.store.general.doneBootstrapping()
    }, 0)
  }

  UNSAFE_componentWillMount() {
    const self = this

    // @ts-ignore
    if (process.env.NODE_ENV === 'development' && module.hot) {
      // @ts-ignore
      module.hot.accept('./routing/RootRoutes', () => {
        const RootRoutes = require('./routing/RootRoutes').default
        self.setState({RootRoutes})
      })
    }
  }

  render() {
    const {RootRoutes} = this.state

    return (
      <AppContainer>
        <>
          <RootRoutes />
        </>
      </AppContainer>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/bootstrap/App.tsx